import { Button, List, ScrollableContainer } from '@emarketer/componentlibrary';
import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../theme/constants';

export const DropdownWrapper = styled(ScrollableContainer)`
  width: 100%;
  height: fit-content;

  .simplebar-content-wrapper {
    border-bottom: 1px solid ${COLOR.BLACK};
  }
`;

export const DropdownItemsWrapper = styled(List)`
  width: 100%;
`;

export const DropdownItem = styled(Button)`
  padding: 10px 8px;
  border-left: 1px solid ${COLOR.BLACK};
  border-right: 1px solid ${COLOR.BLACK};
  background: ${COLOR.WHITE};
  text-align: left;
  width: 100%;
  ${TYPOGRAPHY.BLACK};

  &:hover {
    color: ${COLOR.BLUE};
  }
`;
